module.exports = __webpack_public_path__ + "static/media/My Cases_active_Blue.c026b876.svg";